import {useEffect, useState} from 'react';
import CustomFilterSelect from '../../shared/customFilterSelect';
import HatIcon from '../../assets/icons/hatButton.svg';
import SchoolItem from '../../components/adminSchools/schoolItem';
import BreadCrumb from '../../components/breadCrumb';
import ModalContainer from '../../components/modalContainer';
import CreateSchool from '../../components/adminSchools/createSchool';
import './style.scss';
import {toast} from "react-toastify";
import {getMunicipalities, getNeighborhoods, getResourceTypes, getSchools, getUsers} from "../../API/apiService";

function AdminSchools() {
    // STATES //
    const [openModal, setOpenModal] = useState(false);
    const [neighborhoods, setNeighborhoods] = useState([]);
    const [municipalities, setMunicipalities] = useState([]);
    const [selectedMunicipality, setSelectedMunicipality] = useState(null);
    const [schools, setSchools] = useState([]);
    const [users, setUsers] = useState([]);
    const [schoolsList, setSchoolsList] = useState([]);
    const [resourceTypes, setResourceTypes] = useState([]);

    const info = [
        {
            name: 'Ninguno',
            code: 'N',
            value: 1
        },
        {
            name: 'Preescolar ',
            code: 'IF',
            value: 2
        },
        {
            name: 'Básica Primaria',
            code: 'PR',
            value: 3
        },
        {
            name: 'Básica Secundaria ',
            code: 'SE',
            value: 4
        },
        {
            name: 'Media',
            code: 'ME',
            value: 5
        },
        {
            name: 'Técnico',
            code: 'TE',
            value: 6
        },
        {
            name: 'Tecnólogo',
            code: 'TC',
            value: 7
        },
        {
            name: 'Profesional ',
            code: 'PF',
            value: 8
        },
        {
            name: 'Especialista',
            code: 'ES',
            value: 9
        },
        {
            name: 'Maestría o',
            code: 'MS',
            value: 10
        },
        {
            name: 'Doctorado',
            code: 'PH',
            value: 11
        },
        {
            name: 'Posdoctorado',
            code: 'PHD',
            value: 12
        }
    ];

    const itemsDescription = [
        {
            name: 'Cód. de Escuela',
            code: 'CDE',
            value: 1
        },
        {
            name: 'Tipo de Escuela',
            code: 'TDE',
            value: 2
        },
        {
            name: 'Grupo',
            code: 'GRP',
            value: 0
        },
        {
            name: 'Dinamizador',
            code: 'DMZ',
            value: 3
        },
        {
            name: 'Comuna',
            code: 'CO',
            value: 4
        },
        {
            name: 'Barrio',
            code: 'BAR',
            value: 5
        },
        {
            name: 'Tipo de recurso',
            code: 'TDR',
            value: 6
        },
        {
            name: 'Organización Madrina',
            code: 'OM',
            value: 7
        },
        {
            name: 'Año',
            code: 'AÑ',
            value: 8
        },
        {
            name: 'Acciones',
            code: 'ACC',
            value: 9
        }
    ];

    const schoolType = [
        {
            name: 'NNAJ',
            id: 'NNAJ'
        },
        {
            name: 'ADULTOS',
            id: 'ADULTOS'
        },
        {
            name: 'DIPLOMADOS',
            id: 'DIPLOMADOS'
        },
        {
            name: 'CEC',
            id: 'CEC'
        }
    ];

    const groups = [
        {
            name: 'grupo 1',
            id: 1
        },
        {
            name: 'grupo 2',
            id: 2
        },
        {
            name: 'grupo 3',
            id: 3
        },
        {
            name: 'grupo 4',
            id: 4
        },
        {
            name: 'grupo 5',
            id: 5
        }
    ];

    function onSelectMunicipality(id, name) {
        setSelectedMunicipality(id);
    }

    async function getNeighborhoodsInfo() {
        if (selectedMunicipality) {
            const data = await getNeighborhoods(selectedMunicipality)
            if (data) {
                setNeighborhoods(data)
            }
        }
        return () => {
        }
    }

    async function onCreateSchool(created) {
        if (created) {
            toast('Escuela creada exitosamente!', {
                type: 'success'
            });
            await getSchoolsInfo()
        }
    }

    async function getSchoolsInfo() {
        const info = await getSchools();
        if (info) {
            setSchools(info)
            setSchoolsList(info.map(s => {
                return {
                    id: s.id,
                    name: s.code
                }
            }))
        }
    }


    async function getBasicInfo() {
        const response = await getMunicipalities();
        if (response) {
            setMunicipalities(response);
        }
        const info = await getResourceTypes();
        if (info.length > 0) {
            setResourceTypes(info)
        }
        const usersResponse = await getUsers();
        if (usersResponse.length > 0) {
            setUsers(usersResponse.map(u => {
                return {
                    id: u.id,
                    name: u.full_name,
                    roleName: u.role?.name,
                    roleId: u.role?.id
                }
            }))
        }
        getSchoolsInfo()
        return () => {
        }
    }

    useEffect(() => {
        getBasicInfo();
    }, []);


    useEffect(() => {
        getNeighborhoodsInfo();
    }, [selectedMunicipality]);

    return (
        <>
            {openModal && (
                <ModalContainer>
                    <CreateSchool
                        municipalities={municipalities}
                        schoolType={schoolType}
                        sourceType={resourceTypes}
                        setOpenModal={setOpenModal}
                        users={users}
                        created={onCreateSchool}
                    />
                </ModalContainer>
            )}

            <section className='admin-schools-main-container'>
                <BreadCrumb/>

                <div className='filters-container'>
                    <div className='filters-top'>
                        <p className='title'>FILTROS DE BÚSQUEDA DE ESCUELAS</p>
                        <button
                            onClick={() => setOpenModal(true)}
                            className='add-schools-button'>
                            <div className='icon-container'>
                                <img src={HatIcon} alt=''/>
                            </div>
                            <p>AGREGAR ESCUELAS</p>
                        </button>
                    </div>
                    <div className='filters-content'>
                        <CustomFilterSelect
                            optionsList={schoolsList}
                            placeholder={'Código de escuela'}
                        />
                        <CustomFilterSelect
                            optionsList={schoolType}
                            placeholder={'Tipo de escuela'}
                        />
                        <CustomFilterSelect optionsList={groups} placeholder={'Grupo'}/>
                        <CustomFilterSelect
                            optionsList={info}
                            placeholder={'Dinamizador'}
                        />
                        <CustomFilterSelect optionsList={municipalities} placeholder={'Comuna'}
                                            addInfo={onSelectMunicipality}/>
                        <CustomFilterSelect optionsList={neighborhoods} placeholder={'Barrio'}/>
                        <CustomFilterSelect
                            optionsList={info}
                            placeholder={'Tipo de recurso'}
                        />

                    </div>
                </div>
                <div className='schools-main-container'>
                    <div className='schools-top'>
                        <p className='title'>ESCUELAS</p>
                        <p className='paginator-text'>
                            | Mostrando <span>{schools.length}</span> de <span>{schools.length}</span> resultados |
                        </p>
                    </div>
                    <div className='info-shools-content'>
                        <SchoolItem
                            itemsDescription={itemsDescription}
                            itemSchool={schools}
                            municipalities={municipalities}
                            getSchoolsInfo={getSchoolsInfo}
                        />
                    </div>
                </div>
            </section>
        </>
    );
}

export default AdminSchools;